import React, { useEffect, useState } from "react";
import { FaExchangeAlt, FaPlus, FaTimes, FaUser } from "react-icons/fa";
import "./flights-search-tabs.scss";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { airports } from "./airport";
import { getAllFlights } from "../../../requests/flightsAPI";
import { LocalStorageKeys } from "../../../constants/LocalStorageKeys";
import { toast } from "react-toastify";
import ComingSoonPopup from "../../ui/commons/ComingSoonPopup";
import PassengerModal from "./PassengerModal";
import { DatePicker, ConfigProvider, Button, message } from 'antd';
import FlightsLocationSelector from "./FlightsLocationSelector";
import dayjs from "dayjs";
import {buildFlightsUrl, toTripType} from "../Flights";
import { useNavigate } from "react-router-dom";
import { PlusCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { get } from "../../../utils/request";

const { RangePicker } = DatePicker;

const FlightsSearchTabs = ({ setFlights, setIsLoading, setPassenger, flightsLocationSelections, setFlightsLocationSelections }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [urlSearchParams] = useSearchParams();

  const [messageApi, contextHolder] = message.useMessage();

  const [query, setQuery] = useState("");
  const [filteredAirports, setFilteredAirports] = useState([]);
  const [selectedAirport, setSelectedAirport] = useState(null);
  const [selectedAirports, setSelectedAirports] = useState([]);
  const [passengerParams, setPassengerParams] = useState({adults: 1, children: 0, infants: 0, cabin: 'Economy'})

  const [itineraryClones, setItineraryClones] = useState([]);
  const [focusedInput, setFocusedInput] = useState(null);
  const [openPassengerModal, setOpenPassengerModal] = useState(false);

  console.log(selectedAirports);

  const [tripType, setTripType] = useState("round-trip");
  const [checkIn, setCheckIn] = useState("");
  const [departureDate, setDepartureDate] = useState(null);
  const [arrivalDate, setArrivalDate] = useState(null);

  const [locationSelections, setLocationSelections] = useState([{from: null, to: null, departDateTime: null, arriveDateTime: null}]);

  // Removed check-out; only check-in is used
  var user = localStorage.getItem(LocalStorageKeys.USER_DETAILS);

  function parseFlightSearchParams() {
    let journeyType = toJourneyType(urlSearchParams.get("tripType"));
    if (!journeyType) {
      return null;
    }

    let searchParams = {
      journeyType: journeyType,
      passengers: {
        adults: Number(urlSearchParams.get("adults")),
        children: Number(urlSearchParams.get("children")),
        infants: Number(urlSearchParams.get("infants")),
      },
      filterCriteria: {
        cabin: urlSearchParams.get("cabin"),
      },
      sortBy: "cheapest",
    };

    let journeyRoutes = [];
    if (journeyType === "rt") {
      journeyRoutes.push({
        departAirportCode: urlSearchParams.get("depratureAirport"),
        arriveAirportCode: urlSearchParams.get("arrivalAirport"),
        departCityCode: urlSearchParams.get("departureCity"),
        arriveCityCode: urlSearchParams.get("arrivalCity"),
        departDate: urlSearchParams.get("departureDate"),
      });
      journeyRoutes.push({
        departAirportCode: urlSearchParams.get("arrivalAirport"),
        arriveAirportCode: urlSearchParams.get("depratureAirport"),
        departCityCode: urlSearchParams.get("arrivalCity"),
        arriveCityCode: urlSearchParams.get("departureCity"),
        departDate: urlSearchParams.get("returnDate"),
      });
    } else if (journeyType === "ow") {
      journeyRoutes.push({
        departAirportCode: urlSearchParams.get("depratureAirport"),
        arriveAirportCode: urlSearchParams.get("arrivalAirport"),
        departCityCode: urlSearchParams.get("departureCity"),
        arriveCityCode: urlSearchParams.get("arrivalCity"),
        departDate: urlSearchParams.get("departureDate"),
      });
    } else if (journeyType === "multi") {
      for (let i = 1; i <= 6; i++) {
        if (i <= 2) {
          journeyRoutes.push({
            departAirportCode: urlSearchParams.get(`depratureAirport${i}`),
            arriveAirportCode: urlSearchParams.get(`arrivalAirport${i}`),
            departCityCode: urlSearchParams.get(`departureCity${i}`),
            arriveCityCode: urlSearchParams.get(`arrivalCity${i}`),
            departDate: urlSearchParams.get(`departureDate${i}`),
          });
        } else if (
          !!urlSearchParams.get(`departureCity${i}`) &&
          !!urlSearchParams.get(`arrivalCity${i}`) &&
          !!urlSearchParams.get(`departureDate${i}`)
        ) {
          journeyRoutes.push({
            departAirportCode: urlSearchParams.get(`depratureAirport${i}`),
            arriveAirportCode: urlSearchParams.get(`arrivalAirport${i}`),
            departCityCode: urlSearchParams.get(`departureCity${i}`),
            arriveCityCode: urlSearchParams.get(`arrivalCity${i}`),
            departDate: urlSearchParams.get(`departureDate${i}`),
          });
        }
      }
    }

    let journeyNo = Number(urlSearchParams.get("jn")) ?? 1;
    let selectedItineraries = location.state?.selectedItineraries ?? undefined;

    searchParams.journeyRoutes = journeyRoutes;
    searchParams.journeyNo = journeyNo;
    searchParams.selectedItineraries = selectedItineraries;

    return searchParams;
  }

  async function fetchSearchLocations(query) {
    try {
      const result = await get("/flights/searchLocations", { query });
      return result;
    } catch (err) {
      return [];
    }
  }

  async function fetchSearchLocationsByCityCode(cityCode) {
    try {
      const result = await fetchSearchLocations(cityCode);
      
      for (let i = 0; i < result.length; i++) {
        if (result[i].city?.cityCode === cityCode) {
          return result[i];
        }
      }

      return null;
    } catch (err) {
      return null;
    }
  }

  async function initLocationSelections(flightsSearchParams) {
    let locationSelections = [];
    if (flightsSearchParams.journeyType === 'ow' || flightsSearchParams.journeyType === 'rt') {
      for (let i = 0; i < flightsSearchParams.journeyRoutes.length; i++) {
        let journeyRoute = flightsSearchParams.journeyRoutes[i];
        let depart = await fetchSearchLocationsByCityCode(journeyRoute.departCityCode);
        let arrive = await fetchSearchLocationsByCityCode(journeyRoute.arriveCityCode);
  
        locationSelections.push({from: depart, to: arrive, departDateTime: journeyRoute.departDate, arriveDateTime: i === 0 ? flightsSearchParams.journeyRoutes[1]?.departDate : null});
      }
    } else if (flightsSearchParams.journeyType === 'multi') {
      for (let i = 0; i < flightsSearchParams.journeyRoutes.length; i++) {
        let journeyRoute = flightsSearchParams.journeyRoutes[i];
        let depart = await fetchSearchLocationsByCityCode(journeyRoute.departCityCode);
        let arrive = await fetchSearchLocationsByCityCode(journeyRoute.arriveCityCode);
  
        locationSelections.push({from: depart, to: arrive, departDateTime: journeyRoute.departDate});
      }
    }

    setLocationSelections(locationSelections);
  }

  // useEffect(() => {
  //   if (location.pathname.startsWith("/flights")) {
  //     let flightsSearchParams = parseFlightSearchParams();

  //     let tripType = toTripType(flightsSearchParams.journeyType);
  //     setTripType(tripType);

  //     initLocationSelections(flightsSearchParams);

  //     let passengerParams = {
  //       adults: flightsSearchParams.passengers.adults,
  //       children: flightsSearchParams.passengers.children,
  //       infants: flightsSearchParams.passengers.infants,
  //       cabin: flightsSearchParams.filterCriteria.cabin,
  //     }
  //     setPassengerParams(passengerParams);
  //   }
  // }, [urlSearchParams, location]);

  useEffect(() => {
    if (!!flightsLocationSelections) {
      setLocationSelections(flightsLocationSelections);
    }
  }, [flightsLocationSelections]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setQuery(value);

    if (value.trim() === "") {
      setFilteredAirports([]);
      return;
    }

    const results = airports.filter(
      (a) =>
        a.city.toLowerCase().includes(value.toLowerCase()) ||
        a.country.toLowerCase().includes(value.toLowerCase()) ||
        a.code.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredAirports(results);
  };

  const handleSelect = (airport) => {
    setSelectedAirport(airport);
    setQuery("");
    setFilteredAirports([]);
  };

  const removeAirport = () => {
    setSelectedAirports([]);
  };

  const handleMultiSelect = (airport) => {
    // Single select for destination always
    setSelectedAirports([airport]);
    setQuery("");
    setFilteredAirports([]);
  };

  const clearSelection = () => {
    setSelectedAirport(null);
  };
  const addItineraryClone = () => {
    if (tripType !== " multi-city") return;
    const snapshot = {
      checkIn: "",
      selectedAirport: null,
      selectedAirports: [],
      queryFrom: "",
      filteredFrom: [],
      queryTo: "",
      filteredTo: [],
    };
    setItineraryClones((prev) => [...prev, snapshot]);
  };

  const handleCloneFromSearch = (idx, value) => {
    setItineraryClones((prev) => {
      const draft = [...prev];
      draft[idx].queryFrom = value;
      draft[idx].filteredFrom = value.trim()
        ? airports.filter(
            (a) =>
              a.city.toLowerCase().includes(value.toLowerCase()) ||
              a.country.toLowerCase().includes(value.toLowerCase()) ||
              a.code.toLowerCase().includes(value.toLowerCase())
          )
        : [];
      return draft;
    });
  };

  const handleCloneFromSelect = (idx, airport) => {
    setItineraryClones((prev) => {
      const draft = [...prev];
      draft[idx].selectedAirport = airport;
      draft[idx].queryFrom = "";
      draft[idx].filteredFrom = [];
      return draft;
    });
  };

  const handleCloneToSearch = (idx, value) => {
    setItineraryClones((prev) => {
      const draft = [...prev];
      draft[idx].queryTo = value;
      draft[idx].filteredTo = value.trim()
        ? airports.filter(
            (a) =>
              a.city.toLowerCase().includes(value.toLowerCase()) ||
              a.country.toLowerCase().includes(value.toLowerCase()) ||
              a.code.toLowerCase().includes(value.toLowerCase())
          )
        : [];
      return draft;
    });
  };

  const handleCloneToSelect = (idx, airport) => {
    setItineraryClones((prev) => {
      const draft = [...prev];
      // Single destination only: replace with the selected airport
      draft[idx].selectedAirports = [airport];
      draft[idx].queryTo = "";
      draft[idx].filteredTo = [];
      return draft;
    });
  };

  const removeItineraryClone = (idx) => {
    setItineraryClones((prev) => prev.filter((_, i) => i !== idx));
  };

  const removeCloneAirport = (idx, code) => {
    setItineraryClones((prev) => {
      const draft = [...prev];
      draft[idx].selectedAirports = [];
      return draft;
    });
  };

  const handleCloneCheckInChange = (idx, value) => {
    setItineraryClones((prev) => {
      const draft = [...prev];
      draft[idx].checkIn = value;
      return draft;
    });
  };

  const [isOpen, setIsOpen] = useState(false);

  function closeCommingSoonPopup() {
    setIsOpen(false);
  }

  function setDepartAndArriveDateTime(dates, dateStrings) {
    const departDateTime = dateStrings[0];
    const arriveDateTime = dateStrings[1];

    locationSelections[0].departDateTime = departDateTime;
    locationSelections[0].arriveDateTime = arriveDateTime;
    setLocationSelections([...locationSelections]);

    if (!!setFlightsLocationSelections) {
      setFlightsLocationSelections([...locationSelections]);
    }
  }

  function setDeaprtDateTime(idx, date, dateString) {
    locationSelections[idx]['departDateTime'] = dateString;
    setLocationSelections([...locationSelections]);

    if (!!setFlightsLocationSelections) {
      setFlightsLocationSelections([...locationSelections]);
    }
  }

  function toJourneyType(tripType) {
    if (tripType === "round-trip") {
      return "rt";
    } else if (tripType === "one-way") {
      return "ow";
    } else if (tripType === "multi-city") {
      return "multi";
    } else {
      return null;
    }
  }

  function toJourneyRoutes(locationSelections, journeyType) {
    let journeyRoutes = [];

    if (journeyType === 'rt') {
      if (!locationSelections[0].from?.cityCode || !locationSelections[0].to?.cityCode) {
        messageError("Please select departure and arrival locations before searching.");
        return;
      }
      if (!locationSelections[0].departDateTime || !locationSelections[0].arriveDateTime) {
        messageError("Please select departure and return dates before searching.");
        return;
      }
      if (
        !locationSelections[0]?.from?.airportCode &&
        !locationSelections[0]?.to?.airportCode &&
        locationSelections[0]?.from?.cityCode ===
          locationSelections[0]?.to?.cityCode
      ) {
        messageError(
          "Please select different departure and arrival locations."
        );
        return;
      } else if (
        !!locationSelections[0]?.from?.airportCode &&
        !!locationSelections[0]?.to?.airportCode &&
        locationSelections[0]?.from?.airportCode ===
          locationSelections[0]?.to?.airportCode
      ) {
        messageError("Please select different departure and arrival airports.");
        return;
      }

      journeyRoutes.push({
        departAirportCode: locationSelections[0].from?.airportCode || "",
        arriveAirportCode: locationSelections[0].to?.airportCode || "",
        departCityCode: locationSelections[0].from?.cityCode || "",
        arriveCityCode: locationSelections[0].to?.cityCode || "",
        departDate: locationSelections[0].departDateTime || "",
      });
      journeyRoutes.push({
        departAirportCode: locationSelections[0].to?.airportCode || "",
        arriveAirportCode: locationSelections[0].from?.airportCode || "",
        departCityCode: locationSelections[0].to?.cityCode || "",
        arriveCityCode: locationSelections[0].from?.cityCode || "",
        departDate: locationSelections[0].arriveDateTime || "",
      });
    } else if (journeyType === 'ow') {
      if (!locationSelections[0].from?.cityCode || !locationSelections[0].to?.cityCode) {
        messageError("Please select departure and arrival locations before searching.");
        return;
      }
      if (!locationSelections[0].departDateTime) {
        messageError("Please select all departure dates before searching.");
        return;
      }
      if (
        !locationSelections[0]?.from?.airportCode &&
        !locationSelections[0]?.to?.airportCode &&
        locationSelections[0]?.from?.cityCode ===
          locationSelections[0]?.to?.cityCode
      ) {
        messageError(
          "Please select different departure and arrival locations."
        );
        return;
      } else if (
        !!locationSelections[0]?.from?.airportCode &&
        !!locationSelections[0]?.to?.airportCode &&
        locationSelections[0]?.from?.airportCode ===
          locationSelections[0]?.to?.airportCode
      ) {
        messageError("Please select different departure and arrival airports.");
        return;
      }

      journeyRoutes.push({
        departAirportCode: locationSelections[0].from?.airportCode || "",
        arriveAirportCode: locationSelections[0].to?.airportCode || "",
        departCityCode: locationSelections[0].from?.cityCode || "",
        arriveCityCode: locationSelections[0].to?.cityCode || "",
        departDate: locationSelections[0].departDateTime || "",
      });
    } else if (journeyType === 'multi') {
      for (let i = 0; i < locationSelections.length; i++) {
        if (!locationSelections[i].from?.cityCode || !locationSelections[i].to?.cityCode) {
          messageError("Please select departure and arrival locations before searching.");
          return;
        }
        if (!locationSelections[i].departDateTime) {
          messageError("Please select departure date before searching.");
          return;
        }
        if (
          !locationSelections[i]?.from?.airportCode &&
          !locationSelections[i]?.to?.airportCode &&
          locationSelections[i]?.from?.cityCode ===
            locationSelections[i]?.to?.cityCode
        ) {
          messageError(
            "Please select different departure and arrival locations."
          );
          return;
        } else if (
          !!locationSelections[i]?.from?.airportCode &&
          !!locationSelections[i]?.to?.airportCode &&
          locationSelections[i]?.from?.airportCode ===
            locationSelections[i]?.to?.airportCode
        ) {
          messageError("Please select different departure and arrival airports.");
          return;
        }

        journeyRoutes.push({
          departAirportCode: locationSelections[i].from?.airportCode || "",
          arriveAirportCode: locationSelections[i].to?.airportCode || "",
          departCityCode: locationSelections[i].from?.cityCode || "",
          arriveCityCode: locationSelections[i].to?.cityCode || "",
          departDate: locationSelections[i].departDateTime || "",
        });
      }
    }

    return journeyRoutes;
  }

  function toLocationSelections(journeyRoutes, journeyType) {
    let locationSelections = [];
  
    if (journeyType === 'rt') {
      if (journeyRoutes.length >= 2) {
        locationSelections.push({
          from: {
            airportCode: journeyRoutes[0].departAirportCode || "",
            cityCode: journeyRoutes[0].departCityCode || ""
          },
          to: {
            airportCode: journeyRoutes[0].arriveAirportCode || "",
            cityCode: journeyRoutes[0].arriveCityCode || ""
          },
          departDateTime: journeyRoutes[0].departDate || "",
          arriveDateTime: journeyRoutes[1].departDate || "",
        });
      }
    } else if (journeyType === 'ow') {
      if (journeyRoutes.length >= 1) {
        locationSelections.push({
          from: {
            airportCode: journeyRoutes[0].departAirportCode || "",
            cityCode: journeyRoutes[0].departCityCode || "",
          },
          to: {
            airportCode: journeyRoutes[0].arriveAirportCode || "",
            cityCode: journeyRoutes[0].arriveCityCode || "",
          },
          departDateTime: journeyRoutes[0].departDate || "",
        });
      }
    } else if (journeyType === 'multi') {
      for (let i = 0; i < journeyRoutes.length; i++) {
        locationSelections.push({
          from: {
            airportCode: journeyRoutes[i].departAirportCode || "",
            cityCode: journeyRoutes[i].departCityCode || "",
          },
          to: {
            airportCode: journeyRoutes[i].arriveAirportCode || "",
            cityCode: journeyRoutes[i].arriveCityCode || "",
          },
          departDateTime: journeyRoutes[i].departDate || "",
        });
      }
    }
  
    return locationSelections;
  }

  function onSearch() {
    let journeyType = toJourneyType(tripType);
    let journeyRoutes = toJourneyRoutes(locationSelections, journeyType);
    if (!journeyRoutes) {
      return;
    }

    // journeyType: ow/rt/multi
    // journeyRoutes: [{departAirportCode, arriveAirportCode, departCityCode, arriveCityCode, departDate}],
    // passengers: { adults,children,infants,}
    // filterCriteria: {cabin}
    let flightSearchParams = {
      journeyType: journeyType,
      journeyRoutes: journeyRoutes,
      passengers: {
        adults: passengerParams.adults,
        children: passengerParams.children,
        infants: passengerParams.infants,
      },
      filterCriteria: { cabin: passengerParams.cabin },
    };

    let url = buildFlightsUrl(flightSearchParams, 1);
    navigate(url, {state: {locationSelections}});
  }

  function buildMutilCityLocations() {
    if (locationSelections.length === 1) {
      let locationSelection = { from: null, to: null, departDateTime: null };
      if (!!locationSelections[0]?.to) {
        locationSelection.from = locationSelections[0].to;
      }

      setLocationSelections([locationSelection[0], locationSelection]);

      if (!!setFlightsLocationSelections) {
        setFlightsLocationSelections([locationSelection[0], locationSelection]);
      }
    }

    return locationSelections.map((sel, idx) => {
      return (
        <div key={idx} style={{ marginBottom: "12px" }}>
          <div className="row align-items-center">
            <div className="col-lg-6 px-2">
              <FlightsLocationSelector
                index={idx}
                selections={locationSelections}
                setSelections={setLocationSelections}
              />
            </div>

            <div className="col-lg-3">
              <ConfigProvider
                theme={{
                  components: {
                    DatePicker: {
                      activeBorderColor: "#CBA135",
                      cellRangeBorderColor: "#CBA135",
                      hoverBorderColor: "#CBA135",
                      cellHoverWithRangeBg: "rgba(203,161,53,0.2)",
                      controlHeight: 48,
                    },
                  },
                  token: {
                    colorPrimary: "#CBA135",
                    colorPrimaryBorder: "#CBA135",
                  },
                }}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format="YYYY-MM-DD"
                  value={sel?.departDateTime ? dayjs(sel.departDateTime) : null}
                  onChange={(date, dateString) =>
                    setDeaprtDateTime(idx, date, dateString)
                  }
                />
              </ConfigProvider>
            </div>

            {idx === 0 && (
              <div className="col-lg-3 px-2">
                <div className="form-box">
                  <button
                    type="button"
                    className="room-guests-btn"
                    // data-bs-toggle="modal"
                    // data-bs-target="#passengerModal"
                    onClick={() => setOpenPassengerModal(true)}
                  >
                    <FaUser />{" "}
                    {passengerParams.adults +
                      passengerParams.children +
                      passengerParams.infants}{" "}
                    Passenger
                    {passengerParams.adults +
                      passengerParams.children +
                      passengerParams.infants >
                    1
                      ? "s"
                      : ""}
                    , {passengerParams.cabin}
                  </button>
                </div>
              </div>
            )}

            {idx >= 2 && (
              <div className="col-lg-3 px-1">
                <CloseCircleFilled
                 className="remove-btn"
                  onClick={() => removeAnotherFlight(idx)}
                />
              </div>
            )}
          </div>
        </div>
      );
    });
  }

  function addAnotherFlight() {
    let locationSelection = { from: null, to: null, departDateTime: null };
    let prevLocationSelection = locationSelections[locationSelections.length - 1];
    if (!!prevLocationSelection?.to) {
      locationSelection.from = prevLocationSelection.to;
    }

    setLocationSelections([...locationSelections, locationSelection]);

    if (!!setFlightsLocationSelections) {
      setFlightsLocationSelections([...locationSelections, locationSelection]);
    }
  }

  function removeAnotherFlight(idx) {
    setLocationSelections(locationSelections.filter((_, i) => i !== idx));

    if (!!setFlightsLocationSelections) {
      setFlightsLocationSelections(locationSelections.filter((_, i) => i !== idx));
    }
  }

  const messageSuccess = (content) => {
    messageApi.open({
      type: 'success',
      content: content,
    });
  };

  const messageError = (error) => {
    messageApi.open({
      type: 'error',
      content: error,
    });
  };

  return (
    <section className="flights-search-tabs-section">
      <div className="container">
        <div className="search-tabs-wrapper">
          {contextHolder}

          {/* Tab Content */}
          <div className="tab-content search-form-box" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="flights"
              role="tabpanel"
              aria-labelledby="flights-tab"
            >
              <form
                action=""
                className="flights-form"
                onSubmit={(e) => e.preventDefault()}
              >
                <div className="row align-items-start justify-content-center">
                  <div>
                    <div className="row no-gutters">
                      <div className="col-12">
                        <div className="checks-wrap">
                          <label className="custom-radio">
                            <input
                              type="radio"
                              id="round-trip"
                              name="option"
                              value="round-trip"
                              checked={tripType === "round-trip"}
                              onChange={(e) => setTripType(e.target.value)}
                            />
                            <span className="radio-mark"></span>
                            Round-Trip
                          </label>

                          <label className="custom-radio">
                            <input
                              type="radio"
                              id="one-way"
                              name="option"
                              value="one-way"
                              checked={tripType === "one-way"}
                              onChange={(e) => {
                                if (tripType === " multi-city") {
                                  setSelectedAirports([]);
                                }
                                setTripType(e.target.value);
                              }}
                            />
                            <span className="radio-mark"></span>
                            One-Way
                          </label>

                          <label className="custom-radio">
                            <input
                              type="radio"
                              id="multi-city"
                              name="option"
                              value="multi-city"
                              checked={tripType === "multi-city"}
                              onChange={(e) => setTripType(e.target.value)}
                            />
                            <span className="radio-mark"></span>
                            Multi-City
                          </label>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="inputs-wrapper">
                          {(tripType === "round-trip" ||
                            tripType === "one-way") && (
                            <div className="flight-search-row">
                              <div className="flight-search-row__locations">
                                <FlightsLocationSelector
                                  index={0}
                                  selections={locationSelections}
                                  setSelections={setLocationSelections}
                                  setFlightsLocationSelections={setFlightsLocationSelections}
                                />
                              </div>
                              <div className="flight-search-row__dates">
                                {tripType === "round-trip" && (
                                  <ConfigProvider
                                    theme={{
                                      components: {
                                        DatePicker: {
                                          activeBorderColor: "#CBA135",
                                          cellRangeBorderColor: "#CBA135",
                                          hoverBorderColor: "#CBA135",
                                          cellHoverWithRangeBg:
                                            "rgba(203,161,53,0.2)",
                                          controlHeight: 48,
                                        },
                                      },
                                      token: {
                                        colorPrimary: "#CBA135",
                                        colorPrimaryBorder: "#CBA135",
                                      },
                                    }}
                                  >
                                    <RangePicker
                                      placeholder={[
                                        "Departure date",
                                        "Return date",
                                      ]}
                                      style={{ width: "100%" }}
                                      format="YYYY-MM-DD"
                                      value={[
                                        !!locationSelections &&
                                        !!locationSelections[0]?.departDateTime
                                          ? dayjs(
                                              locationSelections[0]
                                                .departDateTime,
                                              "YYYY-MM-DD"
                                            )
                                          : null,
                                        !!locationSelections &&
                                        !!locationSelections[0]?.arriveDateTime
                                          ? dayjs(
                                              locationSelections[0]
                                                .arriveDateTime,
                                              "YYYY-MM-DD"
                                            )
                                          : null,
                                      ]}
                                      onChange={(dates, dateStrings) =>
                                        setDepartAndArriveDateTime(
                                          dates,
                                          dateStrings
                                        )
                                      }
                                    />
                                  </ConfigProvider>
                                )}
                                {(tripType === "one-way" ||
                                  tripType === "multi-city") && (
                                  <ConfigProvider
                                    theme={{
                                      components: {
                                        DatePicker: {
                                          activeBorderColor: "#CBA135",
                                          cellRangeBorderColor: "#CBA135",
                                          hoverBorderColor: "#CBA135",
                                          cellHoverWithRangeBg:
                                            "rgba(203,161,53,0.2)",
                                          controlHeight: 48,
                                        },
                                      },
                                      token: {
                                        colorPrimary: "#CBA135",
                                        colorPrimaryBorder: "#CBA135",
                                      },
                                    }}
                                  >
                                    <DatePicker
                                      style={{ width: 295 }}
                                      format="YYYY-MM-DD"
                                      value={!!locationSelections[0]?.departDateTime ? dayjs(locationSelections[0]?.departDateTime) : null}
                                      onChange={(date, dateString) =>
                                        setDeaprtDateTime(0, date, dateString)
                                      }
                                    />
                                  </ConfigProvider>
                                )}
                              </div>

                              <div className="flight-search-row__passengers">
                                <div className="form-box">
                                  <button
                                    type="button"
                                    className="room-guests-btn"
                                    // data-bs-toggle="modal"
                                    // data-bs-target="#passengerModal"
                                    onClick={() => setOpenPassengerModal(true)}
                                  >
                                    <FaUser />{" "}
                                    {passengerParams.adults +
                                      passengerParams.children +
                                      passengerParams.infants}{" "}
                                    Passenger
                                    {passengerParams.adults +
                                      passengerParams.children +
                                      passengerParams.infants >
                                    1
                                      ? "s"
                                      : ""}
                                    , {passengerParams.cabin}
                                  </button>
                                </div>
                              </div>
                              <div className="flight-inline-search">
                                <button className="search-btn" onClick={onSearch}>
                                  <img
                                    src="/images/icons/search-icon.svg"
                                    alt="icon"
                                  />{" "}
                                  Search
                                </button>
                              </div>
                            </div>
                          )}
                          {tripType === "multi-city" &&
                            buildMutilCityLocations()}
                          {tripType === "multi-city" &&
                            locationSelections.length < 6 && (
                              <div style={{ marginTop: 15 }}>
                                <div className="row align-items-center">
                                  <div className="col-lg-12 px-2">
                                    <ConfigProvider
                                      theme={{
                                        components: {
                                          Button: {
                                            defaultColor: "#606060",
                                            // defaultBorderColor: '#CBA135',
                                            defaultActiveBorderColor: "#CBA135",
                                            defaultActiveColor: "#CBA135",
                                            defaultHoverBorderColor: "#CBA135",
                                            defaultHoverColor: "#606060",
                                            contentFontSize: 15,
                                          },
                                        },
                                      }}
                                    >
                                      <Button
                                        icon={
                                          <PlusCircleFilled
                                            style={{ color: "#CBA135" }}
                                          />
                                        }
                                        style={{
                                          width: "100%",
                                          height: 48,
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "flex-start",
                                          gap: 8,
                                        }}
                                        onClick={addAnotherFlight}
                                      >
                                        Add another flight
                                      </Button>
                                    </ConfigProvider>
                                  </div>
                                </div>
                              </div>
                            )}
                        </div>
                      </div>

                      {tripType === "multi-city" && <div className="col-12 search-btn-wrapper">
                        <div className="col-xl-2">
                          <button className="search-btn" onClick={onSearch}>
                            <img
                              src="/images/icons/search-icon.svg"
                              alt="icon"
                            />{" "}
                            Search
                          </button>
                        </div>
                      </div>}
                    </div>
                  </div>
                </div>
              </form>
              {tripType === " multi-city" && itineraryClones.length > 0 && (
                <div className="row" style={{ marginTop: "16px" }}>
                  <div className="col-12">
                    {itineraryClones.map((snap, idx) => (
                      <div
                        key={idx}
                        className="inputs-wrapper"
                        style={{
                          border: "1px solid #e5e7eb",
                          borderRadius: "8px",
                          padding: "12px",
                          marginBottom: "12px",
                          background: "#fafafa",
                          position: "relative",
                        }}
                      >
                        <button
                          type="button"
                          onClick={() => removeItineraryClone(idx)}
                          style={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                            color: "#6b7280",
                            display: "flex",
                            alignItems: "center",
                            gap: 6,
                          }}
                          title="Remove"
                        >
                          <FaTimes size={14} />
                          <span style={{ fontSize: 12 }}>Remove</span>
                        </button>
                        <div className="row align-items-center">
                          <div className="col-lg-6 px-2">
                            <div className="flight-select-wrapper">
                              <div
                                style={{
                                  display: "flex",
                                  gap: "8px",
                                  alignItems: "center",
                                }}
                              >
                                <div
                                  style={{
                                    width: "calc(50% - 24px)",
                                    position: "relative",
                                    border: "1px solid #d1d5db",
                                    borderRadius: "8px",
                                    padding: "4px",
                                    background: "#fff",
                                  }}
                                >
                                  {snap.selectedAirport ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        borderRadius: "6px",
                                        padding: "6px 8px",
                                        fontSize: "14px",
                                        width: "fit-content",
                                      }}
                                    >
                                      <strong style={{ fontWeight: 600 }}>
                                        {snap.selectedAirport.city}
                                      </strong>
                                      <span
                                        style={{
                                          color: "#6b7280",
                                          fontSize: "13px",
                                        }}
                                      >
                                        {snap.selectedAirport.code === "ALL"
                                          ? "All airports"
                                          : snap.selectedAirport.code}
                                      </span>
                                      <button
                                        type="button"
                                        onClick={() =>
                                          setItineraryClones((prev) => {
                                            const draft = [...prev];
                                            draft[idx].selectedAirport = null;
                                            return draft;
                                          })
                                        }
                                        style={{
                                          border: "none",
                                          background: "transparent",
                                          cursor: "pointer",
                                          color: "#6b7280",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <FaTimes size={12} />
                                      </button>
                                    </div>
                                  ) : (
                                    <div
                                      style={{
                                        width: "100%",
                                        position: "relative",
                                      }}
                                    >
                                      <input
                                        type="text"
                                        value={snap.queryFrom}
                                        onChange={(e) =>
                                          handleCloneFromSearch(
                                            idx,
                                            e.target.value
                                          )
                                        }
                                        placeholder="Search airport..."
                                        style={{
                                          width: "100%",
                                          padding: "8px 12px",
                                          border: "none",
                                          outline: "none",
                                          fontSize: "14px",
                                        }}
                                      />
                                      {snap.filteredFrom.length > 0 && (
                                        <ul
                                          style={{
                                            position: "absolute",
                                            top: "100%",
                                            left: 0,
                                            right: 0,
                                            maxHeight: "180px",
                                            overflowY: "auto",
                                            background: "#fff",
                                            border: "1px solid #d1d5db",
                                            borderRadius: "8px",
                                            marginTop: "4px",
                                            listStyle: "none",
                                            padding: 0,
                                            zIndex: 10,
                                          }}
                                        >
                                          {snap.filteredFrom.map((airport) => (
                                            <li
                                              key={airport.code}
                                              onClick={() =>
                                                handleCloneFromSelect(
                                                  idx,
                                                  airport
                                                )
                                              }
                                              style={{
                                                padding: "8px 12px",
                                                cursor: "pointer",
                                              }}
                                              onMouseEnter={(e) =>
                                                (e.currentTarget.style.background =
                                                  "#f3f4f6")
                                              }
                                              onMouseLeave={(e) =>
                                                (e.currentTarget.style.background =
                                                  "transparent")
                                              }
                                            >
                                              <strong>{airport.city}</strong> (
                                              {airport.code}) –{" "}
                                              {airport.country}
                                            </li>
                                          ))}
                                        </ul>
                                      )}
                                    </div>
                                  )}
                                </div>
                                {/* <div className="swap-icon mx-2">
                                  <FaExchangeAlt color="#c9a43b" />
                                </div> */}
                                <div
                                  style={{
                                    width: "calc(50% - 24px)",
                                    position: "relative",
                                    border: "1px solid #d1d5db",
                                    borderRadius: "8px",
                                    padding: "4px",
                                    background: "#fff",
                                  }}
                                >
                                  {snap.selectedAirports.length > 0 ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        borderRadius: "6px",
                                        padding: "6px 8px",
                                        fontSize: "14px",
                                        width: "fit-content",
                                      }}
                                    >
                                      <strong style={{ fontWeight: 600 }}>
                                        {snap.selectedAirports[0].city}
                                      </strong>
                                      <span
                                        style={{
                                          color: "#6b7280",
                                          fontSize: "13px",
                                        }}
                                      >
                                        {snap.selectedAirports[0].code === "ALL"
                                          ? "All airports"
                                          : snap.selectedAirports[0].code}
                                      </span>
                                      <button
                                        type="button"
                                        onClick={() => removeCloneAirport(idx)}
                                        style={{
                                          border: "none",
                                          background: "transparent",
                                          cursor: "pointer",
                                          color: "#6b7280",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <FaTimes size={12} />
                                      </button>
                                    </div>
                                  ) : (
                                    <div
                                      style={{
                                        width: "100%",
                                        position: "relative",
                                      }}
                                    >
                                      <input
                                        type="text"
                                        value={snap.queryTo}
                                        onChange={(e) =>
                                          handleCloneToSearch(
                                            idx,
                                            e.target.value
                                          )
                                        }
                                        placeholder="Search airport..."
                                        style={{
                                          width: "100%",
                                          padding: "8px 12px",
                                          border: "none",
                                          outline: "none",
                                          fontSize: "14px",
                                        }}
                                      />
                                      {snap.filteredTo.length > 0 && (
                                        <ul
                                          style={{
                                            position: "absolute",
                                            top: "100%",
                                            left: 0,
                                            right: 0,
                                            maxHeight: "180px",
                                            overflowY: "auto",
                                            background: "#fff",
                                            border: "1px solid #d1d5db",
                                            borderRadius: "8px",
                                            marginTop: "4px",
                                            listStyle: "none",
                                            padding: 0,
                                            zIndex: 10,
                                          }}
                                        >
                                          {snap.filteredTo.map((airport) => (
                                            <li
                                              key={airport.code}
                                              onClick={() =>
                                                handleCloneToSelect(
                                                  idx,
                                                  airport
                                                )
                                              }
                                              style={{
                                                padding: "8px 12px",
                                                cursor: "pointer",
                                              }}
                                              onMouseEnter={(e) =>
                                                (e.currentTarget.style.background =
                                                  "#f3f4f6")
                                              }
                                              onMouseLeave={(e) =>
                                                (e.currentTarget.style.background =
                                                  "transparent")
                                              }
                                            >
                                              <strong>{airport.city}</strong> (
                                              {airport.code}) –{" "}
                                              {airport.country}
                                            </li>
                                          ))}
                                        </ul>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3 px-2">
                            <div className="form-box chech-inputs">
                              <div className="d-grid date-picker-wrap">
                                <input
                                  type="date"
                                  value={snap.checkIn}
                                  onChange={(e) =>
                                    handleCloneCheckInChange(
                                      idx,
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {tripType === " multi-city" && (
                <div style={{ marginTop: "8px" }}>
                  <button
                    type="button"
                    className="btn add-btn"
                    onClick={addItineraryClone}
                  >
                    <FaPlus style={{ marginRight: 6 }} /> Add
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <ComingSoonPopup
        isOpen={isOpen}
        onOk={closeCommingSoonPopup}
        onCancel={closeCommingSoonPopup}
      />

      <PassengerModal
        open={openPassengerModal}
        onCancel={() => setOpenPassengerModal(false)}
        passengerParams={passengerParams}
        setPassengerParams={setPassengerParams}
      />
    </section>
  );
};

export default FlightsSearchTabs;
